<template>
  <div>
    <div class="page-bar" style="margin-bottom:10px;" v-show="$route.name != 'quizzes_show'">
      <ul class="page-breadcrumb">
          <li>
              <router-link :to="{name:'quizzes_list'}">Questionnaires</router-link>
          </li>
          <li v-show="$route.params.slug">
              <i class="fa fa-circle"></i>
              <router-link :to="{name:'quizzes_responses',params:{slug:$route.params.slug}}">{{$route.params.slug}}</router-link>
          </li>
          <li v-show="$route.name=='quizzes_edit'">
              <i class="fa fa-circle"></i>
              <router-link :to="{name:'quizzes_edit'}">Edition</router-link>
          </li>
          <li v-show="$route.name=='quizzes_create'">
              <i class="fa fa-circle"></i>
              <router-link :to="{name:'quizzes_create'}">Création</router-link>
          </li>
          <li v-show="$route.name=='quizzes_responses'">
              <i class="fa fa-circle"></i>
              <router-link :to="{name:'quizzes_responses',params:{slug:$route.params.slug}}">Liste des réponses</router-link>
          </li>
          <li v-show="$route.name=='quizzes_preconizations' || $route.name == 'quizzes_preconizations_create_action' || $route.name == 'quizzes_preconizations_edit_action' ">
              <i class="fa fa-circle"></i>
              <router-link :to="{name:'quizzes_preconizations'}">Préconisations</router-link>
          </li>
          <li v-show="$route.name=='quizzes_preconizations_create_action'">
              <i class="fa fa-circle"></i>
              <router-link :to="{name:'quizzes_preconizations_create_action'}">Nouvelle</router-link>
          </li>
          <li v-show="$route.name=='quizzes_preconizations_edit_action'">
              <i class="fa fa-circle"></i>
              <router-link :to="{name:'quizzes_preconizations_edit_action', params:{id:$route.params.id}}"> Action n°{{$route.params.id}}</router-link>
          </li>
          <li v-show="$route.name=='quizzes_export_pdf'">
              <i class="fa fa-circle"></i>
              <router-link :to="{name:'quizzes_export_pdf', params:{slug:$route.params.slug}}"> Export PDF</router-link>
          </li>
      </ul>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'quizzes',
  data () {
    return{
    }
  },
  mounted:function(){
  },
  activated:function(){
  },
  methods:{
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// quizzes.vue?79e39c86